import React from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { Headline } from '../../headline/headline';
import { Button } from '../../form/button/button';

type BannerSharedPortfolioProps = {
    onDiscountClick: () => void;
};

export const BannerSharedPortfolio: React.FC<BannerSharedPortfolioProps> = observer(({ onDiscountClick }) => {
    const { t } = useTranslation();

    return (
        <div className="flex items-center justify-between gap-small rounded-[9999px] border border-border bg-body py-small pr-medium pl-large shadow-large max-md:flex-col max-md:items-center max-md:justify-center max-md:rounded-large max-md:p-small max-md:text-center">
            <div className="grow text-center [&_h3]:max-md:text-center">
                <Headline level={3} align={'left'} variant="primary" gap="none">
                    {t('blocks.banner.sharedPortfolio.headline')}
                </Headline>
            </div>
            <div className="flex justify-end gap-medium">
                <Button variant={'primary'} size={'medium'} gradient shadow onClick={onDiscountClick}>
                    {t('blocks.banner.sharedPortfolio.button')}
                </Button>
            </div>
        </div>
    );
});
